import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect, useDispatch } from 'react-redux';
import { getCustomers, deleteCustomer, updateCustomersPagination } from '../../store/actions/customer/customer_action';
import { IconButton, makeStyles, Paper, Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import TablePagination from '../ui_components/table_pagination';
import { REACT_ROUTES } from '../../constants/react_routes';
import history from '../../services/history';
import { RecentActors } from '@material-ui/icons';
import ActionsComponent from '../ui_components/actions_component';
import DigitalRecordModal from './digital_record_modal';

const useStyles = makeStyles((theme) => ({
	paper: {
        width: '100%',
        marginTop: theme.spacing(3),
        overflowX: 'auto'
    },
    table: {
        minWidth: 500
    }
}));

const CustomersTable = ({ customers: { collection, totalCount, page, rowsPerPage, filters } }) => {
    const { paper, table, tableRow } = useStyles();
    const dispatch = useDispatch();

    const [digitalRecordOpen, setDigitalRecordOpen] = useState(false);
    const [customerUuid, setCustomerUuid] = useState(null);
    const [customerName, setCustomerName] = useState('');
    const [customerBirthYear, setCustomerBirthYear] = useState('');

    useEffect(() => {
        if (!collection.length) {
            dispatch(getCustomers({ page, rowsPerPage, filters }));
        }
    }, []);

    const handleClickDigitalRecord = (uuid, firstName, lastName, customerBirthYear) => {
        setCustomerUuid(uuid);
        setCustomerName(`${firstName} ${lastName}`);
        setCustomerBirthYear(customerBirthYear);
        setDigitalRecordOpen(true);
    }

    const handleClick = (uuid) => {
        history.push(`${REACT_ROUTES.CUSTOMER}/${uuid}`);
    }

    const handleDeleteCustomer = (uuid) => {
        dispatch(deleteCustomer(uuid))
            .then(() => dispatch(getCustomers({ page, rowsPerPage, filters })));
    }

    return (
        <Paper className={paper}>
            <Table aria-label="table" className={table}>
                <TableHead>
                    <TableRow>
                        <TableCell>Ime i prezime</TableCell>
                        <TableCell>Email</TableCell>
                        <TableCell>Adresa</TableCell>
                        <TableCell>Telefon</TableCell>
                        <TableCell>JMBG</TableCell>
                        <TableCell>Radnik</TableCell>
                        <TableCell align="right">Akcije</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {collection.map(({ uuid, firstName, lastName, shortName, email, address, phone, jmbg, worker, deletable, customerBirthYear }, index) =>
                        <TableRow hover key={index} className={tableRow}>
                            <TableCell>
                                {`${ firstName } ${ lastName } ${ shortName || '' }`}
                            </TableCell>
                            <TableCell>{ email }</TableCell>
                            <TableCell>{ address }</TableCell>
                            <TableCell>{ phone }</TableCell>
                            <TableCell>{ jmbg }</TableCell>
                            <TableCell>{ worker && `${worker?.firstName} ${worker?.lastName}` }</TableCell>
                            <TableCell align="right">
                                <IconButton onClick={() => handleClickDigitalRecord(uuid, firstName, lastName, customerBirthYear)}>
                                    <RecentActors />
                                </IconButton>
                                <ActionsComponent
                                    handleEdit={() => handleClick(uuid)}
                                    handleDelete={() => handleDeleteCustomer(uuid)}
                                    deletable={deletable}
                                    label="klijenta"
                                />
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>
                <TablePagination
                    page={page}
                    count={totalCount}
                    rowsPerPage={rowsPerPage}
                    filters={filters}
                    updatePagination={updateCustomersPagination}
                />
            </Table>
            <DigitalRecordModal
                customerUuid={customerUuid}
                customerName={customerName}
                customerBirthYear={customerBirthYear}
                open={digitalRecordOpen}
                setOpen={setDigitalRecordOpen}
            />
        </Paper>
    )
}

CustomersTable.propTypes = {
    customers: PropTypes.object
}

const mapStateToProps = (state) => ({
    customers: state.customers
});

export default connect(mapStateToProps)(CustomersTable);
